<template>
    <el-drawer
        :before-close="cancel"
        :title="`模板列表`"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        width="500px">
        <div class="flex flex-direction">
            <div class="flex align-center padding-lr-sm">
                <el-input v-model="searchName" placeholder="请输入关键字"/>
                <el-button
                    class="btn small margin-left-xs"
                    type="primary"
                    @click="search"><i class="el-icon-search"></i>搜索
                </el-button>
            </div>
            <div ref="refresh" class="infinite-list-wrapper flex flex-direction padding-lr-sm" style="height: calc(100vh - 200px);overflow:auto">
                <ul
                    class="list"
                    v-infinite-scroll="init"
                    :infinite-scroll-delay="20"
                    :infinite-scroll-distance="20"
                    :infinite-scroll-disabled="more">
                    <div class="template-item flex flex-direction margin-top-sm" v-for="(item,index) in lists" :key="index">
                        <div class="flex flex-direction  padding-sm">
                            <div class="text-bold text-black text-df">{{item.title}}</div>
                            <div class="text-sm ovHide5 margin-top-sm">{{item.desc}}</div>
                        </div>
                        <div class="operate flex align-center">
                            <el-button class="flex-sub" type="text" @click="copyInfo(item)">引用</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button class="flex-sub" type="text" @click="showItem(item.id)">查看全文</el-button>
                        </div>
                    </div>
                </ul>
                <div class="self-center margin-top-xs" v-if="loading"><i class="el-icon-loading"></i>加载中...</div>
                <div class="self-center margin-top-xs" v-if="more">没有更多了</div>
            </div>
            <div class=" flex flex-direction">


            </div>
        </div>
        <template-detail-dialog :dialog-visible="templateDetailDialog" :aid="cur_aid" @watchState="watchState"></template-detail-dialog>
    </el-drawer>
</template>

<script>

import {getTemplateList} from "@/api";
import {formatHtml} from "@/utils/utils";
import TemplateDetailDialog from "@/views/web/manager/page/standard/components/TemplateDetailDialog";

export default {
    name: "TemplateDialog",
    components: {TemplateDetailDialog},
    data() {
        return {
            searchName:'',
            page: 1,
            limit: 9,
            total: 0,
            lists:[],
            more:false,
            loading:false,
            templateDetailDialog:false,
            cur_aid:0
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        type:{
            type:Number,
            default: 0
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            let _data = await getTemplateList(this.searchName,this.type,this.page,this.limit)
            _data.data.data.map(item=>{
                item.isrmind= false
                item.desc = formatHtml(item.content)
            })
            if (this.page === 1) this.lists = []
            this.lists = [...this.lists,..._data.data.data]
            this.loading =false
            if (this.page === _data.data.last_page) {
                this.more = true;
            } else {
                this.more = false
                this.page ++
            }
        },
        showItem(id) {
            this.cur_aid = id
            this.templateDetailDialog = true
        },
        search() {
            this.$refs.refresh.scrollTo(0,0)
            this.page = 1
            this.init()
        },
        copyInfo(item) {
            this.$emit('watchState', item)
        },
        cancel() {
            this.$emit('watchState', false)
        },
        watchState() {
            this.templateDetailDialog = false
        }
    },
    filters: {},
    watch: {
    }
}
</script>

<style lang="scss" scoped>

.template-item {
    width: 100%;
    border: 1px solid #eeeeee;
    .operate {
        border-top: 1px solid #eeeeee;
        height: 50px;
    }
}

</style>